import { StatCard } from "@/components/atoms/modernise-with-ai/StatCard";
import { Database, CheckCircle, XCircle, Zap } from "lucide-react";

interface ResultsGridProps {
  results: {
    totalProcessed: number;
    successful: number;
    failed: number;
    performanceGain: number;
  };
}

export const ResultsGrid: React.FC<ResultsGridProps> = ({ results }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
    <StatCard
      icon={Database}
      iconColor="bg-blue-100 dark:bg-blue-900"
      label="Total Processed"
      value={results.totalProcessed}
    />
    <StatCard
      icon={CheckCircle}
      iconColor="bg-green-100 dark:bg-green-900"
      label="Successful"
      value={results.successful}
      valueColor="text-green-600"
    />
    <StatCard
      icon={XCircle}
      iconColor="bg-red-100 dark:bg-red-900"
      label="Failed"
      value={results.failed}
      valueColor="text-red-600"
    />
    <StatCard
      icon={Zap}
      iconColor="bg-purple-100 dark:bg-purple-900"
      label="Performance Gain"
      value={`${results.performanceGain}%`}
      valueColor="text-purple-600"
    />
  </div>
);
